import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { auth } from "../../config/firebase";
import { sendPasswordResetEmail } from "firebase/auth";

const Login = () => {
  const { user, login, error } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [input, setInput] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [resetMsg, setResetMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  // THÊM: Nhận thông báo từ AuthContext (vô hiệu hóa)
  const banMessage = location.state?.message;

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim() || !password.trim()) return;
    setLoading(true);
    try {
      await login(input.trim(), password, rememberMe);
    } catch (err) {}
    finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!input.trim()) {
      setResetMsg({ type: 'info', text: 'Vui lòng nhập email hoặc tên đăng nhập trước!' });
      return;
    }
    const email = input.includes('@') ? input.trim() : input.trim() + '@xudoan.com';
    if (email.endsWith('@xudoan.com')) {
      setResetMsg({ type: 'info', text: 'Tài khoản của bạn dùng email nội bộ. Vui lòng liên hệ Quản trị viên (Admin) để được cấp lại mật khẩu mới.' });
      setTimeout(() => setResetMsg(null), 8000);
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMsg({ type: 'success', text: `✅ Đã gửi email reset đến ${email}. Vui lòng kiểm tra hộp thư (cả mục Spam).` });
    } catch (err) {
      setResetMsg({ type: 'error', text: 'Không thể gửi email. Vui lòng liên hệ Admin.' });
    }
    setTimeout(() => setResetMsg(null), 8000);
  };

  return (
    <div className="flex w-full min-h-screen bg-gray-100 font-sans">
      <div className="w-full min-h-screen flex items-center justify-center p-6 md:p-8 bg-gray-100">
        <div className="w-full max-w-md space-y-8 bg-white p-8 md:p-10 rounded-xl shadow-lg border border-gray-200">
          <div className="text-center space-y-2">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center">
                <span className="material-symbols-outlined text-3xl text-white">church</span>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-gray-800">XỨ ĐOÀN MARIA GORETTI VÂN CƯƠNG</h1>
            <p className="text-sm text-gray-500">Hệ thống quản lý Giáo Lý</p>
          </div>

          {/* THÊM: Hiển thị thông báo vô hiệu hóa */}
          {banMessage && (
            <div className="bg-red-50 text-red-700 p-4 rounded-md text-sm flex items-center gap-2 border border-red-200">
              <span className="material-symbols-outlined text-xl">block</span>
              <span>{banMessage}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="username">Email hoặc tên đăng nhập</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400">
                  <span className="material-symbols-outlined">person</span>
                </span>
                <input type="text" id="username" value={input} onChange={e => setInput(e.target.value)} autoComplete="username" autoFocus required className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600 sm:text-sm" placeholder="Nhập email hoặc tên đăng nhập" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="password">Mật khẩu</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400">
                  <span className="material-symbols-outlined">lock</span>
                </span>
                <input type={showPassword ? "text" : "password"} id="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600 sm:text-sm" placeholder="••••••••" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
                  <span className="material-symbols-outlined text-xl">{showPassword ? "visibility_off" : "visibility"}</span>
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input id="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">Ghi nhớ đăng nhập</label>
              </div>
              <div className="text-sm">
                <button type="button" onClick={handleForgotPassword} className="font-medium text-blue-600 hover:text-blue-500">Quên mật khẩu?</button>
              </div>
            </div>
            {error && <div className="bg-red-50 text-red-700 p-3 rounded-md text-sm flex items-center gap-2"><span className="material-symbols-outlined text-base">error</span><span>{error}</span></div>}
            {resetMsg && <div className={`p-3 rounded-md text-sm flex items-center gap-2 ${resetMsg.type === 'success' ? 'bg-green-50 text-green-800' : resetMsg.type === 'error' ? 'bg-red-50 text-red-800' : 'bg-blue-50 text-blue-800'}`}><span className="material-symbols-outlined text-base">{resetMsg.type === 'success' ? 'check_circle' : resetMsg.type === 'error' ? 'error' : 'info'}</span><span>{resetMsg.text}</span></div>}
            <button type="submit" disabled={loading} className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50">
              {loading ? "Đang đăng nhập..." : "Đăng nhập"}
            </button>
          </form>
          <div className="text-center space-y-1 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">Dành riêng cho Huynh Trưởng &amp; Giáo Lý Viên</p>
            <p className="text-xs text-gray-400">v1.0 · Firebase</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;